<template>
  <VDataGridV2
      id="transport-downtimes-registry"
      :loader="dataLoader"
      :context-menu="TransportDowntimesService.contextMenu"
      @row:dblclick="openDowntimeCard"
  >
    <VDataGridColumnV2
        id="id"
        label="№"
        width="52px"
    >
      <template #default="{ row }">
        <VLink @click="openDowntimeCard(row)">
          {{ $core.utils.string.formatWithDelimiter(row.id) }}
        </VLink>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="transportOrder"
        label="№ ЗТК"
        width="100px"
    >
      <template #default="{ row }">
        <VLink @click="openTransportOrder(row)">
          {{ $core.utils.string.formatWithDelimiter(row.transportOrder.id) }}
        </VLink>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="transportOrderType"
        label="Тип"
        width="200px"
        content-class="ellipsis"
    >
      <template #default="{ row }">
        {{ TransportOrder.types.get(row.transportOrder.type)?.name ?? '--' }}
      </template>
    </VDataGridColumnV2>

    <!-- Статус — то же правило, что в TransportOrder.status: у простоя ЗТК лежит сырым объектом -->
    <VDataGridColumnV2
        id="transportOrderStatus"
        label="Статус"
        width="120px"
    >
      <template #default="{ row }">
        <template v-if="row.transportOrder.isFinished === true">Завершён</template>
        <template v-else-if="row.transportOrder.isConfirmed === true">Утверждён</template>
        <template v-else-if="row.transportOrder.isConfirmed === false">В работе</template>
        <template v-else>--</template>
      </template>
    </VDataGridColumnV2>

    <!-- Стоимость перевозки ЗТК: у простоя ЗТК лежит сырым объектом, Sum гидрируем здесь -->
    <VDataGridColumnV2
        id="transportCostPlanned"
        label="Стоимость план"
        width="150px"
        content-align="right"
    >
      <template #default="{ row }">
        {{ $core.utils.hydrate(row.transportOrder.transportCostPlanned, Sum.fromServer)?.format($core.currentPartner?.country.localCurrency.code) ?? '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="transportCostActual"
        label="Стоимость факт"
        width="150px"
        content-align="right"
    >
      <template #default="{ row }">
        {{ $core.utils.hydrate(row.transportOrder.transportCostActual, Sum.fromServer)?.format($core.currentPartner?.country.localCurrency.code) ?? '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="cost"
        label="Цена простоя"
        width="150px"
        content-align="right"
    >
      <template #default="{ row }">
        {{ row.cost?.format(row.currencyCode) ?? '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="reason"
        label="Причина"
        width="300px"
        content-class="ellipsis"
    >
      <template #default="{ row }">
        <div class="ellipsis" :title="row.reason">
          {{ row.reason || '--' }}
        </div>
      </template>
    </VDataGridColumnV2>
  </VDataGridV2>
</template>

<style lang="scss" scoped>
</style>

<script lang="ts">
import TransportDowntimesService from '@/domains/TransportDowntime/TransportDowntimesService';
import TransportOrdersService    from '@/domains/TransportOrders/TransportOrdersService';
import TransportOrder            from '@/domains/TransportOrders/TransportOrder';
import type TransportDowntime    from '@/domains/TransportDowntime/TransportDowntime';
import DataGridLoader            from '@/lib/components/VDataGridV2/DataGridLoader';
import Sum                       from '@/core/types/Sum';

export default defineComponent({
  name: 'TransportDowntimesRegistry',

  components: {
  },

  props: {
  },

  emits: [
  ],

  setup() {
    return {
      TransportDowntimesService,
      TransportOrder,
      Sum,
    };
  },

  data() {
    return {
      dataLoader: new DataGridLoader(TransportDowntimesService.getListPaginated),
    };
  },

  created() {
  },

  mounted() {
  },

  beforeUnmount() {
  },

  computed: {
  },

  methods: {
    /** Открывает карточку простоя и обновляет реестр, если простой сохранили */
    async openDowntimeCard(row: TransportDowntime): Promise<void> {
      if (await this.$core.dialogs.TransportDowntimeCard.showAsPromise({ downtime: row })) {
        await this.dataLoader.refresh();
      }
    },

    /** Открывает карточку ЗТК простоя и обновляет реестр, если ЗТК сохранили */
    async openTransportOrder(row: TransportDowntime): Promise<void> {
      if (await TransportOrdersService.showTransportOrderDialog(row.transportOrder.id) ?? null) {
        await this.dataLoader.refresh();
      }
    },
  },
});
</script>
